import { z } from 'zod'

/**
 * GET /lc/users/access-details — the identity + entitlement payload the console
 * hangs everything off. Shape captured live from the demo tenant (see
 * docs/inventory). This is the ONE authoritative description of who the user is
 * and what they can reach; the console's Session is built from it.
 */

export const scopeAccess = z.object({
  role: z.string(),
  scope_id: z.string(),
  scope_name: z.string(),
})

export const clusterAccess = z.object({
  access_type: z.string(),
  clusterId: z.string(),
  clusterName: z.string(),
  licenseType: z.string(),
  productType: z.string(),
  scope_access: z.array(scopeAccess).default([]),
})

export const accessDetails = z.object({
  SSID: z.string().optional(),
  userId: z.string().optional(),
  orgId: z.string().optional(),
  name: z.string().optional(),
  emailId: z.string().optional(),
  userType: z.string().optional(),
  isRoot: z.boolean().nullable().optional(),
  isAdmin: z.boolean().nullable().optional(),
  isOrgAdmin: z.boolean().nullable().optional(),
  EULA: z.boolean().optional(),
  isPolicyAccepted: z.boolean().optional(),
  version: z.string().optional(),
  access: z.array(clusterAccess).default([]),
})

export const accessDetailsResponse = z.object({ data: accessDetails })

export type ScopeAccess = z.output<typeof scopeAccess>
export type ClusterAccess = z.output<typeof clusterAccess>
/** Output type: `.default([])` means `access` is always present after parsing. */
export type AccessDetails = z.output<typeof accessDetails>
